<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-60" @mousedown="_dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: _getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <i class="fa-light fa-save mr-2" style="font-size: 20px"></i>
                  {{ headerTittleLabel }}
                </h4>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="_handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <hr class="mx-auto">
                  <b-row class="justify-content-start no-gutters">
                    <b-button-group class="d-inline-flex">
                      <b-button v-if="!readonly" variant="tertiary" class="config-buttons-title" @click="addJsonParam">Add Param</b-button>
                    </b-button-group>
                  </b-row>
                  <b-row v-for="(header, index) in jsonParamArray" :key="'header-http-' + index" class="form-group">
                      <b-col :cols="readonly ? '4' : '3'">
                        <form-write-group-label-input
                          v-model="header.key"
                          :disabled="readonly"
                          isMandatory
                          :maxLength="512"
                          :inputLabel="$t('common.routing.header_http.key')"
                          :placeholderValue="$t('common.routing.uri')"
                          :inputAriaLabel="$t('common.routing.header_http.group_label') + ' ' + (index + 1)"
                        />
                      </b-col>
                      <b-col cols="4">
                        <label for="header-http-type">
                          {{ $t('common.routing.header_http.type') }}<span class="color-red"> * </span>
                        </label>
                        <select id="header-http-type" required autocomplete="off" class="form-control" v-model="jsonParamArray[index].type" :disabled="readonly"
                          @change="changeParams(index)">
                          <option v-for="(paramsKey, paramsKeyIndex) in paramsKeyList" :key="'header-http-key-' + paramsKeyIndex" :value="paramsKey">
                            {{ $t('administration.tpp_client.params_dyn.' + paramsKey.replace(/[<>]/g, '').replace(/\s/g, '-')) }}
                          </option>
                          <option value="">{{ $t('common.routing.header_http_dyn.manual') }}</option>
                        </select>
                      </b-col>
                      <b-col cols="4">
                        <form-write-group-label-input v-if="!jsonParamArray[index].type"
                          v-model="jsonParamArray[index].value"
                          :disabled="readonly"
                          :maxLength="512"
                          :inputLabel="$t('common.routing.header_http.value')"
                          :placeholderValue="$t('common.routing.uri')"
                          :inputAriaLabel="$t('common.routing.header_http.value') + ' ' + (index + 1)"
                        />
                      </b-col>
                      <b-col v-if="!readonly" cols="1" class="d-flex align-items-center justify-content-center">
                        <i class="fa fa-trash mt-4 pt-3" @click="deleteJsonParamValue(index)"/>
                      </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer" v-if="!readonly">
            <i>{{ $t('administration.tpp_client.how_to_save') }}</i>
            <b-button variant="primary"
              @click="saveJsonParam()">{{ $t('common.sve') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import _ from 'lodash'

export default {
  name: 'ChoiceBICCountry',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      headerIndex: 1,
      jsonParamArray: [],
      paramsKeyList: [
        '<url>',
        '<amount>',
        '<debtor_name>',
        '<creditor_name>',
        '<remittance_information>'
      ],
      readonly: true,
      type: 1
    }
  },
  computed: {
    headerTittleLabel () {
      let additionnal = this.readonly ? '' : '_set'
      return this.type === 0 ?
        (this.$i18n.t('administration.tpp_client.email_parameters' + additionnal)) :
        (this.$i18n.t('administration.tpp_client.sms_parameters' + additionnal))
    }
  },
  created () {
    this.headerIndex = this.data.index
    this.jsonParamArray = this.data.params
    this.readonly = this.data.readonly
    this.type = this.data.type
    window.addEventListener('resize', this._changeMaxHeightClient)
    window.addEventListener('mousedown', this._handleMouseDown)
    window.addEventListener('mouseup', this._handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this._changeMaxHeightClient)
  },
  methods: {
    _changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: ' + maxHeight + 'px')
    },
    _dontClose (e) {
      e.stopPropagation()
    },
    _getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    _handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    _handleMouseUp () {
      this.mousedown = false
    },
    addJsonParam () {
      this.jsonParamArray.push({ type: '' })
    },
    changeParams (index) {
      this.jsonParamArray[index].value = this.jsonParamArray[index].type
    },
    deleteJsonParamValue (index) {
      this.jsonParamArray.splice(index, 1)
    },
    saveJsonParam () {
      this.$bus.$emit('config-set-json-params', { params: _.cloneDeep(this.jsonParamArray), type: this.type })
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
